import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, notFound } from "@tanstack/react-router"

import { PageContent } from "@/components/common/page-content"
import { PageHeader } from "@/components/common/page-header"
import { ReviewActions } from "@/features/reviews/components/review-actions"
import { SnapshotPageSections } from "@/features/reviews/components/snapshot-page"
import { reviewQueries } from "@/queries/reviews"
import type { Review } from "@/types/review"

function personPage(review: Review, appointmentId: string) {
  return review.pages.find(
    (page) => page.kind === "person" && page.key === appointmentId
  )
}

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/reviews/$reviewId/people/$appointmentId/"
)({
  loader: async ({ context, params }) => {
    const review = await context.queryClient.ensureQueryData(
      reviewQueries.detail(params.reviewId)
    )

    if (!personPage(review, params.appointmentId)) {
      throw notFound()
    }
  },
  component: ReviewPersonPage,
})

function ReviewPersonPage() {
  const { reviewId, appointmentId } = Route.useParams()
  const { data: review } = useSuspenseQuery(reviewQueries.detail(reviewId))
  const page = personPage(review, appointmentId)

  return (
    <>
      <PageHeader
        title={page?.title ?? "Person"}
        actions={<ReviewActions review={review} />}
      />
      <PageContent>
        {page ? <SnapshotPageSections page={page} /> : null}
      </PageContent>
    </>
  )
}
